// extracted by mini-css-extract-plugin
export default {"MintPriceIcon":"MintPriceIcon_MintPriceIcon__-rERA"};